import apiDef from './def'

/* eslint-disable */
const VueApi = {
  install (Vue, options) {
    if (options && options.name) {
      Vue[options.name] = apiDef
      Object.defineProperties(Vue.prototype, {
        [options.name]: { get() { return apiDef } }
      })
    } else {
      Vue._api = apiDef
      Object.defineProperties(Vue.prototype, {
        _api: { get() { return apiDef } }
      })
    }
    Vue.prototype.$api = apiDef;

    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(VueApi)
    }
  }
}

export default VueApi



// WEBPACK FOOTER //
// ./src/api/index.js